import type { SVGProps } from 'react';
const DawnFlagLR = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 2a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
    />
    <path
      fill="#F5F5F5"
      fillRule="evenodd"
      d="M20 .5H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h18a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 20 .5M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
    <mask
      id="dawn-flag-LR_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g mask="url(#dawn-flag-LR_svg__a)">
      <path
        fill="#E1244A"
        fillRule="evenodd"
        d="M22 0H10.476v2.133H22zm0 4.267H10.476V6.4H22zM10.476 8.533H22v2.134H10.476zM22 12.8H0v2.133h22z"
        clipRule="evenodd"
      />
      <path fill="#0C3F8E" d="M0 0h10.476v10.667H0z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M5.239 6.581 3.39 7.922l.682-2.203L2.25 4.344l2.268-.02.72-2.19.721 2.19 2.269.02L6.404 5.72l.682 2.203z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagLR;
